import { forwardRef, InputHTMLAttributes } from "react";
import { useFormFieldState } from "../FormComponentHooks";
import styles from "./FormField.module.less";
import { extractValueProps, FormFieldProps } from "./FormFieldProps";

export type InputStringProps =
  & InputHTMLAttributes<HTMLInputElement>
  & FormFieldProps<string>;

export const InputString = forwardRef<HTMLInputElement, InputStringProps>(
  function InputString(props, ref) {
    const [valueProps, { ...inputProps }] = extractValueProps(props);
    const [value, setValue] = useFormFieldState(valueProps, "");

    return (
      <input
        ref={ref}
        type="text"
        className={styles.input}
        {...inputProps}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    );
  },
);
